/**
 * STRUTTURA DEL CESP — organigramma ufficiale 2026 (documento del Centro, aggiornamento marzo 2026).
 * Per prudenza privacy non vengono pubblicati i recapiti personali dei membri: solo nomi e affiliazioni.
 */
export interface Carica { ruolo: string; nome: string }
export interface Membro { nome: string; affiliazione?: string }

export const presidenza: Carica[] = [
  { ruolo: "Presidente", nome: "Paolo Levrero" },
  { ruolo: "Direttore", nome: "Giancarla Sola" },
  { ruolo: "Segretario", nome: "Francesca Marcone" },
  { ruolo: "Responsabile Amministrativo delle Ricerche", nome: "Ilaria Barbieri Wurtz" },
];

/** Indirizzo di segreteria come da organigramma ufficiale. */
export const segreteriaEmail = "cesp.genova@gmail.com";

export const comitatoScientifico: Membro[] = [
  { nome: "Alberto Filipe Araújo", affiliazione: "Universidade do Minho, Braga — Portogallo" },
  { nome: "Jutta Breithausen", affiliazione: "Bergische Universität Wuppertal — Germania" },
  { nome: "Rita Casale", affiliazione: "Bergische Universität Wuppertal — Germania" },
  { nome: "Ángel Garcia del Dujo", affiliazione: "Universidad de Salamanca — Spagna" },
  { nome: "Mario Gennari", affiliazione: "Università degli Studi di Genova — Italia" },
  { nome: "Anna Kaiser", affiliazione: "Università degli Studi di Genova — Italia" },
  { nome: "Mary Beth Kenkel", affiliazione: "Florida Institute of Technology, Melbourne — Usa" },
  { nome: "Jürgen Oelkers", affiliazione: "Universität Zürich — Svizzera" },
  { nome: "Giancarla Sola", affiliazione: "Università degli Studi di Genova — Italia" },
  { nome: "Jean-Jacques Wunenburger", affiliazione: "Université Jean Moulin Lyon 3 — Francia" },
];

/** Consiglio di Ricerca — aggiornato al 27 marzo 2026 (in memoriam contrassegnato con † come nel documento). */
export const consiglioRicerca: string[] = [
  "Amadu Alba Chiara", "Ballabene Barbara", "Barbè Elisa", "Baschiazzore Sonia",
  "Borello Claudio †", "Buonomo Luigi", "Calzetta Francesca", "Cambieri Simone",
  "Canepa Giorgia", "Cantatore Francesca", "Cantatore Roberto", "Casali Luisa",
  "Cepollina Marco", "Cherici Tatiana", "Cornero Laura", "Creazzo Anna",
  "De Leo Alessandro", "Falco Giuliano", "Fiorucci Stefania", "Gennari Mario",
  "Giancardi Luciano", "Guerci Ilaria", "Kaiser Anna", "Lanaro Tecla",
  "Milani Pietro", "Oneto Beatrice", "Pagnacco Mara", "Picardo Beatrice",
  "Pigoni Martina", "Pizzorno Elisa", "Poldi Allai Paola", "Rivolo Sergio",
  "Rubbo Giuseppe", "Ruotolo Giusi", "Sguerso Fulvio †", "Simoncini Francesco",
  "Spallarossa Stefano", "Tizzi Edoardo Valter", "Tizzi Silvia",
];
